import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    beforeEnter() {
      window.location.href = "https://www.carpaboletos.com/";
    },
  },
  {
    path: "/event/:idEvento",
    name: "Event",
    component: () => import("../views/EventView.vue"),
    children: [
      {
        path: "/typeTicket/:idEvento",
        name: "TypeTicket",
        component: () => import("../views/TypeTicketView.vue"),
        meta: {
          title: "Tipo de entrada | Carpa Boletos",
        },
      },
      {
        path: "/location/:idEvento",
        name: "Location",
        component: () => import("../views/LocationView.vue"),
        meta: {
          title: "Localidad | Carpa Boletos",
        },
      },
      {
        path: "/calendar/:idEvento",
        name: "Calendar",
        component: () => import("../views/CalendarView.vue"),
        meta: {
          title: "Calendario | Carpa Boletos",
        },
      },
      {
        path: "/locationV2/:idEvento",
        name: "LocationV2",
        component: () => import("../views/LocationV2View.vue"),
        meta: {
          title: "Localidad | Carpa Boletos",
        },
      },
      {
        path: "/cart/:idEvento",
        name: "Cart",
        component: () => import("../views/CartView.vue"),
        meta: {
          title: "Resumen | Carpa Boletos",
        },
      },
      {
        path: "/cartV2/:idEvento",
        name: "CartV2",
        component: () => import("../views/CartV2View.vue"),
        meta: {
          title: "Resumen | Carpa Boletos",
        },
      },
    ],
  },
  {
    path: "/cupones/:idEvento",
    name: "Cupones",
    component: () => import("../views/CuponesView.vue"),
    meta: {
      title: "Cupones | Carpa Boletos",
    },
  },
  {
    path: "/coomeva/:idEvento",
    name: "Coomeva",
    component: () => import("../views/CoomevaView.vue"),
    meta: {
      title: "Coomeva | Carpa Boletos",
    },
  },
  {
    path: "/promo/:code",
    name: "Promo",
    component: () => import("../views/PromoView.vue"),
    meta: {
      title: "Promoción | Carpa Boletos",
    },
  },
  {
    path: "/auth/:idReserva",
    name: "Auth",
    component: () => import("../views/AuthView.vue"),
    meta: {
      title: "Inicia sesión | Carpa Boletos",
    },
  },
  {
    path: "/forms/:idReserva",
    name: "Forms",
    component: () => import("../views/FormsView.vue"),
    meta: {
      title: "Formularios | Carpa Boletos",
    },
  },
  {
    path: "/delivery/:idReserva",
    name: "Delivery",
    component: () => import("../views/DeliveryView.vue"),
    meta: {
      title: "Entrega | Carpa Boletos",
    },
  },
  {
    path: "/checkout/:idReserva",
    name: "Checkout",
    component: () => import("../views/CheckoutView.vue"),
    meta: {
      title: "Confirmación | Carpa Boletos",
    },
  },
  {
    path: "/status/:idReserva",
    name: "Status",
    component: () => import("../views/StatusView.vue"),
    meta: {
      title: "Estado | Cara",
    },
  },
  {
    path: "/ticket/:idReserva",
    name: "Ticket",
    component: () => import("../views/TicketView.vue"),
    meta: {
      title: "Descarga tus entradas | Cara",
    },
  },

  //Rutas para abonos
  {
    path: "/seasonTicket/:idGrupo",
    name: "seasonTicket",
    component: () => import("../views/SeasonTicketView.vue"),
    children: [
      {
        path: "/seasonTypeTicket/:idGrupo",
        name: "SeasonTypeTicket",
        component: () => import("../views/SeasonTypeTicketView.vue"),
        meta: {
          title: "Tipo de entrada | Carpa Boletos",
        },
      },
      {
        path: "/seasonTypeBook/:idGrupo",
        name: "SeasonTypeBook",
        component: () => import("../views/SeasonTypeBookView.vue"),
        meta: {
          title: "Modalidad de compra | Carpa Boletos",
        },
      },
      {
        path: "/seasonLocationAuto/:idGrupo",
        name: "SeasonLocationAuto",
        component: () => import("../views/SeasonLocationAutoView.vue"),
        meta: {
          title: "Localidad | Carpa Boletos",
        },
      },
      {
        path: "/seasonLocation/:idGrupo",
        name: "SeasonLocation",
        component: () => import("../views/SeasonLocationView.vue"),
        meta: {
          title: "Localidad | Carpa Boletos",
        },
      },
      {
        path: "/seasonCart/:idGrupo",
        name: "SeasonCart",
        component: () => import("../views/SeasonCartView.vue"),
        meta: {
          title: "Resumen | Carpa Boletos",
        },
      },
    ],
  },
  //Rutas para abonos
  {
    path: "/seasonCoupons/:idGrupo",
    name: "SeasonCoupons",
    component: () => import("../views/SeasonCouponsView.vue"),
    meta: {
      title: "Cupones | Carpa Boletos",
    },
  },
  {
    path: "/seasonAuth/:idAbono",
    name: "SeasonAuth",
    component: () => import("../views/SeasonAuthView.vue"),
    meta: {
      title: "Inicia sesión | Carpa Boletos",
    },
  },
  {
    path: "/seasonDelivery/:idAbono",
    name: "SeasonDelivery",
    component: () => import("../views/SeasonDeliveryView.vue"),
    meta: {
      title: "Entrega | Carpa Boletos",
    },
  },
  {
    path: "/seasonCheckout/:idAbono",
    name: "SeasonCheckout",
    component: () => import("../views/SeasonCheckoutView.vue"),
    meta: {
      title: "Confirmación | Carpa Boletos",
    },
  },
  {
    path: "/seasonTicketDownload/:idAbono",
    name: "SeasonTicketDownload",
    component: () => import("../views/SeasonTicketDownloadView.vue"),
    meta: {
      title: "Descarga tus entradas | Carpa Boletos",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorView",
    beforeEnter() {
      window.location.href = "https://carpaboletos.com";
    },
  },

  //Rutas para transacciones
  {
    path: "/authTransaction/:idTransaccion",
    name: "AuthTransaction",
    component: () => import("../views/AuthTransactionView.vue"),
    meta: {
      title: "Inicia sesión | Carpa Boletos",
    },
  },
  {
    path: "/deliveryTransaction/:idTransaccion",
    name: "DeliveryTransaction",
    component: () => import("../views/DeliveryTransactionView.vue"),
    meta: {
      title: "Entrega | Carpa Boletos",
    },
  },
  {
    path: "/checkoutTransaction/:idTransaccion",
    name: "CheckoutTransaction",
    component: () => import("../views/CheckoutTransactionView.vue"),
    meta: {
      title: "Confirmación | Carpa Boletos",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? " Carpa Boletos";
});

export default router;
